module.exports = {"messages":"Missatges"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/Messages.json
// module id = 593
// module chunks = 1